import api from "../config/Axios.config";

export const getFilteredPosts = async (filters) => {
    const posts = await api.post('/posts/filter', {filters});
    if(posts.data.data.length > 0) {
        return posts.data.data;
    }

    return [];
}